import React from 'react';
import MetricCard from './MetricCard';
import { IconAlert, IconTrendDown, IconTrendUp, IconChart, IconCheck } from './Icons';
import './Dashboard.css';

/** Static results preview behind the Pro lock on Blowout / % Rule pages. */
function RiskResultsSamplePreview({ riskMode }) {
  if (riskMode === 'apexMae') {
    return (
      <div className="dashboard risk-results-sample-preview">
        <div className="dashboard-header">
          <h2 className="dashboard-title">50% Rule Results</h2>
        </div>
        <div
          className="apex-mae-simplified-box"
          style={{
            borderColor: '#10b981',
            backgroundColor: 'rgba(16, 185, 129, 0.1)',
          }}
        >
          <div className="apex-mae-simplified-header">
            <div
              className="apex-mae-status-badge"
              style={{ backgroundColor: '#10b981', color: '#ffffff' }}
            >
              <IconCheck size={16} style={{ display: 'inline', marginRight: '0.5rem' }} />
              WITHIN LIMIT
            </div>
            <h3 className="apex-mae-simplified-title">50% Rule (CONSISTENCY/WINDFALL)</h3>
          </div>
          <div className="apex-mae-simplified-content">
            <div className="apex-mae-limits-container" style={{ display: 'flex', gap: '2rem', flexWrap: 'wrap' }}>
              <div className="apex-mae-key-metric apex-mae-card-mae-limit" style={{ flex: '1', minWidth: '220px' }}>
                <div className="apex-mae-card-header-stack">
                  <span
                    className="apex-mae-card-badge"
                    style={{
                      backgroundColor: 'rgba(16, 185, 129, 0.2)',
                      color: '#10b981',
                      border: '1px solid #10b981',
                    }}
                  >
                    WITHIN LIMIT
                  </span>
                  <div className="apex-mae-metric-label">Maximum Loss Allowed (Consistency Limit)</div>
                </div>
                <div className="apex-mae-metric-value" style={{ color: '#10b981' }}>
                  $5,250.00
                </div>
                <div className="apex-mae-metric-subtitle">50% of $10,500.00</div>
              </div>
              <div
                className="apex-mae-card-worst-loss"
                style={{
                  flex: '1',
                  minWidth: '220px',
                  padding: '1.25rem',
                  background: 'rgba(255, 255, 255, 0.03)',
                  borderRadius: '8px',
                  border: '1px solid rgba(255, 255, 255, 0.05)',
                }}
              >
                <div className="comparison-label" style={{ fontSize: '0.9rem', color: 'rgba(255, 255, 255, 0.7)' }}>
                  Strategy&apos;s Worst Historical Loss Day
                </div>
                <div className="comparison-value safe" style={{ fontSize: '2rem', fontWeight: 700, textAlign: 'center' }}>
                  $1,300.00
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="dashboard risk-results-sample-preview">
      <div className="dashboard-header">
        <h2 className="dashboard-title">Blowout Risk Results</h2>
      </div>
      <div
        className="blow-account-indicator"
        style={{ borderColor: '#ef4444', backgroundColor: 'rgba(239, 68, 68, 0.08)' }}
      >
        <div className="blow-account-status">
          <span className="blow-account-label">Account Blowout Risk:</span>
          <span className="blow-account-value" style={{ color: '#ef4444' }}>
            NO GO
          </span>
        </div>
        <div className="contract-type-badge">
          Contract Type: <strong>NQ</strong>
        </div>
        <p className="blow-account-message">
          HIGH RISK: Historical worst-day loss exceeds your max trailing drawdown at this contract size.
        </p>
        <div className="blow-account-probability">
          Probability of end-of-day losses exceeding max drawdown: <strong>40.0%</strong>
        </div>
      </div>
      <div className="dashboard-header risk-score-header" style={{ marginTop: '1rem', marginBottom: '1rem' }}>
        <div className="risk-score-display">
          <span className="risk-score-label">Risk Score:</span>
          <span className="risk-score-value" style={{ color: '#f59e0b' }}>
            66/100
          </span>
        </div>
      </div>
      <div className="metrics-grid">
        <MetricCard
          title="Risk Score"
          value="66/100"
          subtitle="Moderate Risk"
          icon={<IconAlert size={20} />}
          trend="moderate"
        />
        <MetricCard
          title="Highest Loss"
          value={<span className="metric-value-loss">$8,190.00</span>}
          subtitle="32.76% of account (9 contracts)"
          icon={<IconTrendDown size={20} />}
          trend="negative"
        />
        <MetricCard
          title="Average Loss"
          value={<span className="metric-value-loss">$4,376.25</span>}
          subtitle="17.51% of account"
          icon={<IconChart size={20} />}
          trend="negative"
        />
        <MetricCard
          title="Max Profit"
          value={<span className="metric-value-profit">$7,650.00</span>}
          subtitle="30.60% of account"
          icon={<IconTrendUp size={20} />}
          trend="positive"
        />
      </div>
    </div>
  );
}

export default RiskResultsSamplePreview;
